(function () {
  var buttonWrap = document.getElementById("omk-whatsapp-button");
  if (!buttonWrap) return;

  var link = buttonWrap.querySelector(".omk-whatsapp-button__link");
  if (!link) return;

  var STORAGE_PREFIX = "omk_";
  var PARAM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "fbclid",
    "wbraid",
    "gbraid"
  ];

  function storageKey(key) {
    return STORAGE_PREFIX + key;
  }

  function getStoredValue(key) {
    try {
      return localStorage.getItem(storageKey(key)) || "";
    } catch (e) {
      return "";
    }
  }

  function setStoredValue(key, value) {
    try {
      if (value) {
        localStorage.setItem(storageKey(key), value);
      }
    } catch (e) {}
  }

  function persistAttributionParams() {
    try {
      var params = new URLSearchParams(window.location.search);

      PARAM_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) {
          setStoredValue(key, value);
        }
      });

      if (!localStorage.getItem(storageKey("session_start_at"))) {
        localStorage.setItem(storageKey("session_start_at"), new Date().toISOString());
      }

      if (!localStorage.getItem(storageKey("landing_page"))) {
        localStorage.setItem(storageKey("landing_page"), window.location.href);
      }

      if (!localStorage.getItem(storageKey("first_referrer"))) {
        localStorage.setItem(storageKey("first_referrer"), document.referrer || "(direct)");
      }
    } catch (e) {}
  }

  function buildPayload() {
    var payload = {
      event: "whatsapp_click",
      event_id: "wa_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8),

      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      page_type: buttonWrap.dataset.pageType || "",

      whatsapp_url: buttonWrap.dataset.whatsappUrl || link.href || "",

      session_start_at: getStoredValue("session_start_at"),
      landing_page: getStoredValue("landing_page"),
      first_referrer: getStoredValue("first_referrer"),

      utm_source: getStoredValue("utm_source"),
      utm_medium: getStoredValue("utm_medium"),
      utm_campaign: getStoredValue("utm_campaign"),
      utm_content: getStoredValue("utm_content"),
      utm_term: getStoredValue("utm_term"),

      gclid: getStoredValue("gclid"),
      fbclid: getStoredValue("fbclid"),
      wbraid: getStoredValue("wbraid"),
      gbraid: getStoredValue("gbraid")
    };

    if (buttonWrap.dataset.productId) {
      payload.product_id = buttonWrap.dataset.productId || "";
      payload.product_name = buttonWrap.dataset.productName || "";
      payload.product_sku = buttonWrap.dataset.productSku || "";
      payload.product_type = buttonWrap.dataset.productType || "";
      payload.product_price = buttonWrap.dataset.productPrice || "";
    }

    return payload;
  }

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function sendGA4Event(payload) {
    if (typeof window.gtag !== "function") return;

    window.gtag("event", "whatsapp_click", {
      debug_mode: true,
      event_category: "engagement",
      event_label: payload.page_type || payload.page_title || "whatsapp",
      value: 1,

      page_location: payload.page_location,
      page_title: payload.page_title,
      page_type: payload.page_type,

      session_start_at: payload.session_start_at,
      landing_page: payload.landing_page,
      first_referrer: payload.first_referrer,

      utm_source: payload.utm_source,
      utm_medium: payload.utm_medium,
      utm_campaign: payload.utm_campaign,
      utm_content: payload.utm_content,
      utm_term: payload.utm_term,

      gclid: payload.gclid,
      fbclid: payload.fbclid,
      wbraid: payload.wbraid,
      gbraid: payload.gbraid,

      product_id: payload.product_id || "",
      product_name: payload.product_name || "",
      product_sku: payload.product_sku || "",
      product_type: payload.product_type || "",
      product_price: payload.product_price || ""
    });
  }

  function sendMetaPixelEvent(payload) {
    if (typeof window.fbq !== "function") return;

    window.fbq("trackCustom", "WhatsAppClick", {
      page_location: payload.page_location,
      page_path: payload.page_path,
      page_title: payload.page_title,
      page_type: payload.page_type,

      session_start_at: payload.session_start_at,
      landing_page: payload.landing_page,
      first_referrer: payload.first_referrer,

      utm_source: payload.utm_source,
      utm_medium: payload.utm_medium,
      utm_campaign: payload.utm_campaign,
      utm_content: payload.utm_content,
      utm_term: payload.utm_term,

      gclid: payload.gclid,
      fbclid: payload.fbclid,
      wbraid: payload.wbraid,
      gbraid: payload.gbraid,

      product_id: payload.product_id || "",
      product_name: payload.product_name || "",
      product_sku: payload.product_sku || "",
      product_type: payload.product_type || "",
      product_price: payload.product_price || ""
    });
  }

  var fired = false;

  function trackWhatsAppIntent() {
    if (fired) return;
    fired = true;

    var payload = buildPayload();

    pushDataLayer(payload);
    sendGA4Event(payload);
    sendMetaPixelEvent(payload);

    console.log("OMK WhatsApp tracked:", payload);

    setTimeout(function () {
      fired = false;
    }, 1200);
  }

  persistAttributionParams();

  link.addEventListener("pointerdown", trackWhatsAppIntent, { passive: true });
  link.addEventListener("click", trackWhatsAppIntent);
})();